<template>
  <div id="app_content" class="admin admin-mod-art">
    <h1 class="titolo">Impostazione modulo-articolo</h1>
    <small>I moduli-articolo sono in ordine decrescente</small>
    <h6><em>Doppio click sulla riga per editare il modulo-articolo</em></h6>

    <input class="search-box" type="text" placeholder="Codice modulo articolo..." v-model="searchTxt"
           @keyup="searchCard">

    <div class="ultimi-20">
      <div class="intestazione">
        <div class="cella codice">Codice</div>
        <div class="cella macrofamiglia">Macrofamiglia</div>
        <div class="cella famiglia">Famiglia</div>
        <div class="cella microfamiglia">Microfamiglia</div>
        <div class="cella categoria">Categoria</div>
        <div class="cella colore">Colore</div>
      </div>
      <div :id='card.codice.replace(/\s|[/]/g, "")' class="riga" v-for="(card, i) in cards" :key="i"
           @dblclick="openEdit(card.codice.replace(/\s|[/]/g, ''))">
        <div class="contenuto">
          <b-tooltip class="cella codice" :label="card.id.toString()">
            {{ card.codice }}
          </b-tooltip>

          <b-tooltip class="cella macrofamiglia" :label="card.macrofamily.descrizione" multilined>
            {{ card.macrofamily.codice }}
          </b-tooltip>

          <b-tooltip v-if="card.family" class="cella famiglia" :label="card.family.descrizione" multilined>
            {{ card.family.codice }}
          </b-tooltip>

          <b-tooltip v-else class="cella famiglia" :label="'n/a'">-</b-tooltip>

          <b-tooltip v-if="card.microfamily" class="cella microfamiglia" :label="card.microfamily.descrizione"
                     multilined>
            {{ card.microfamily.codice }}
          </b-tooltip>

          <b-tooltip v-else class="cella microfamiglia" :label="'n/a'">-</b-tooltip>

          <b-tooltip v-if="card.category" class="cella categoria" :label="card.category.descrizione" multilined>
            {{ card.category.codice }}
          </b-tooltip>

          <b-tooltip v-else class="cella categoria" :label="'n/a'">-</b-tooltip>

          <b-tooltip v-if="card.color" class="cella colore" :label="card.color.descrizione" multilined>
            {{ card.color.codice }}
          </b-tooltip>

          <b-tooltip v-else class="cella colore" :label="'n/a'">-</b-tooltip>
        </div>

        <div class="edit-card">
          <input type="text" v-model="edit.new_card">
          <select v-if="hierachy" name="macrofamiglia" id="macrofamiglia" v-model="edit.cod_macrofamiglia"
                  @change="loadFamilies(edit.cod_macrofamiglia)">
            <option v-for="macro in hierachy.macrofamiglie" :value="macro.codice">
              {{ macro.codice }} - {{macro.descrizione}}
            </option>
          </select>
          <select name="famiglia" id="famiglia" v-model="edit.cod_famiglia"
                  @change="loadMicrofamilies(edit.cod_famiglia)">
            <option v-if="families" v-for="fam in families" :value="fam.codice">
              {{ fam.codice }} - {{fam.descrizione}}
            </option>
            <option v-if="families.length === 0" value="" selected>
              Selezionare macrofamiglia...
            </option>

          </select>
          <select name="microfamiglia" id="microfamiglia" v-model="edit.cod_microfamiglia">
            <option v-if="microfamilies" v-for="mic in microfamilies" :value="mic.codice">
              {{ mic.codice }} - {{mic.descrizione}}
            </option>

          </select>
          <select v-if="hierachy" name="categoria" id="categoria" v-model="edit.cod_categoria">
            <option v-for="cat in hierachy.categorie" :value="cat.codice">
              {{ cat.codice }} - {{cat.descrizione}}
            </option>

          </select>
          <select v-if="hierachy" name="colore" id="colore" v-model="edit.cod_colore">
            <option v-for="col in hierachy.colori" :value="col.codice">
              {{ col.codice }} - {{col.descrizione}}
            </option>

          </select>
          <div class="button-cards">
            <button @click="editCards(card.codice)">Salva modifiche</button>
            <button @click="confirmCustomDelete(card.codice)">Elimina modulo articolo</button>
            <button @click="closeEdit(card.codice.replace(/\s|[/]/g, ''))">Annulla</button>
          </div>
        </div>

      </div>
      <div v-if="pagination" class="paginazione">
        <div v-if="pagination.current_page > 1" class="prev" @click="precedente"> <<</div>
        <div v-else class="prev fine"> -</div>
        <div class="pagine">Pagina {{ pagination.current_page }} di {{ pagination.last_page }}</div>
        <div v-if="pagination.current_page < 8" class="next" @click="prossima"> >></div>
        <div v-else class="next fine"> -</div>
      </div>

    </div>
    <div class="wrap">
      <div class="titolo-new">
        Inserimento nuovo modulo - articolo
      </div>
      <div class="inser-heading">
        <div class="head">Codice</div>
        <div class="head">Macrofamiglia</div>
        <div class="head">Famiglia</div>
        <div class="head">Microfamiglia</div>
        <div class="head">Categoria</div>
        <div class="head">Colore</div>
      </div>
      <div class="insert-card">
        <input type="text" v-model="create.new_card">
        <select v-if="hierachy" name="macro" id="macro" v-model="create.cod_macrofamiglia"
                @change="loadFamilies(create.cod_macrofamiglia)">
          <option v-for="macro in hierachy.macrofamiglie" :value="macro.codice" >
            {{ macro.codice }} - {{macro.descrizione}}
          </option>
        </select>
        <select name="fam" id="fam" v-model="create.cod_famiglia" @change="loadMicrofamilies(create.cod_famiglia)">
          <option v-if="families" v-for="fam in families" :value="fam.codice">
            {{ fam.codice }} - {{fam.descrizione}}
          </option>
          <option v-if="families.length === 0" value="" selected>
            Selezionare macrofamiglia...
          </option>
        </select>
        <select name="micro" id="micro" v-model="create.cod_microfamiglia">
          <option v-if="microfamilies" v-for="mic in microfamilies" :value="mic.codice">
            {{ mic.codice }} - {{mic.descrizione}}
          </option>
        </select>
        <select v-if="hierachy" name="cat" id="cat" v-model="create.cod_categoria">
          <option v-for="cat in hierachy.categorie" :value="cat.codice" >
            {{ cat.codice }} - {{cat.descrizione}}
          </option>
        </select>
        <select v-if="hierachy" name="col" id="col" v-model="create.cod_colore">
          <option v-for="col in hierachy.colori" :value="col.codice" >
            {{ col.codice }} - {{col.descrizione}}
          </option>
        </select>
        <button @click="insertCard">Inserisci</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mod-art",
  data() {
    return {
      cards: null,
      searchTxt: '',
      hierachy: null,
      pagination: null,
      families: [],
      microfamilies: [],
      edit: {
        new_card: null,
        cod_macrofamiglia: null,
        cod_famiglia: null,
        cod_microfamiglia: null,
        cod_categoria: null,
        cod_colore: null
      },
      create: {
        new_card: null,
        cod_macrofamiglia: null,
        cod_famiglia: null,
        cod_microfamiglia: null,
        cod_categoria: null,
        cod_colore: null
      }
    }
  },
  mounted() {
    this.fetchHierachy()
    this.fetchCards()
  },
  methods: {
    insertCard() {
      axios({
        method: 'get',
        url: window.location.origin + '/admin/mod-articolo/api/insert',
        params: {
          codice: this.create.new_card.toUpperCase(),
          cod_macrofamiglia: this.create.cod_macrofamiglia,
          cod_famiglia: this.create.cod_famiglia,
          cod_microfamiglia: this.create.cod_microfamiglia,
          cod_categoria: this.create.cod_categoria,
          cod_colore: this.create.cod_colore,
        }
      }).then(res => {
        if (res.data.esito) {
          this.alertCustom('Successo', `Modulo articolo ${this.create.new_card.toUpperCase()} salvato correttamente`)
          this.create = {
            new_card: null,
            cod_macrofamiglia: null,
            cod_famiglia: null,
            cod_microfamiglia: null,
            cod_categoria: null,
            cod_colore: null
          }
        } else {
          this.alertCustom('Errore', res.data.message)
        }
      })
    },
    searchCard() {
      if (this.searchTxt.length > 1) {
        axios({
          method: 'get',
          url: window.location.origin + '/admin/mod-articolo/api/search',
          params: {
            codice: this.searchTxt
          }
        }).then(res => {
          this.cards = res.data.cards
          this.pagination = null
        }).catch(err => {
          console.log(err.response.data.message)
        })
      } else if (this.searchTxt === '') {
        this.fetchCards()
      }
    },
    confirmCustomDelete(code) {
      this.$buefy.dialog.confirm({
        title: 'Elimina modulo articolo',
        message: `Sicuro di voler eliminare il modulo articolo <strong> ${code} </strong>?`,
        confirmText: 'Cancella',
        cancelText: 'Annulla',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteCard(code)
      })
    },
    deleteCard(code) {
      axios({
        method: 'get',
        url: window.location.origin + '/admin/mod-articolo/api/delete',
        params: {
          cod_card: code
        }
      }).then(res => {
        location.reload()
      })
    },
    alertCustom(title, message) {
      this.$buefy.dialog.confirm({
        title: title,
        message: message,
        confirmText: 'Ok',
        onConfirm: () => location.reload()
      })
    },
    loadFamilies(macro) {
      this.families = []
      this.hierachy.famiglie.forEach(el => {
        if (el.codice_macrofamiglia === macro) {
          this.families.push(el)
        }
      })
    },
    loadMicrofamilies(fam) {
      this.microfamilies = []
      this.hierachy.microfamiglie.forEach(el => {
        if (el.codice_famiglia === fam) {
          this.microfamilies.push(el)
        }
      })
    },
    fetchHierachy() {
      axios({
        method: 'get',
        url: window.location.origin + '/admin/mod-articolo/api/hierachy',
      }).then(res => {
        this.hierachy = res.data
      })
    },
    editCards(cod_card) {
      axios({
        method: 'get',
        url: window.location.origin + '/admin/mod-articolo/api/edit',
        params: {
          codice: cod_card,
          new_card: this.edit.new_card ? this.edit.new_card.toUpperCase() : null,
          cod_macrofamiglia: this.edit.cod_macrofamiglia,
          cod_famiglia: this.edit.cod_famiglia,
          cod_microfamiglia: this.edit.cod_microfamiglia,
          cod_categoria: this.edit.cod_categoria,
          cod_colore: this.edit.cod_colore
        }
      }).then(res => {
        if(res.data.esito) {
          this.alertCustom('Successo', 'Modulo articolo modificato con successo!')
        } else {
          console.log(res.data)
          this.alertCustom('Errore', res.data.message)
        }
      }).catch(err => {
        this.alertCustom('Errore', err.response.data.message)
      })
    },
    fetchCards() {
      axios({
        method: 'get',
        url: window.location.origin + '/admin/mod-articolo/api/fetch',
      }).then(res => {
        this.cards = res.data.data.cards
        this.pagination = res.data.meta
      }).catch(err => {
        console.log(err.response.data.message)
      })
    },
    prossima() {
      let currentPage = this.pagination.current_page
      let riga = $('.riga')
      riga.children('.edit-card').css('display', 'none');
      riga.css('background-color', 'unset');
      riga.css('font-weight', 'unset');
      axios({
        method: 'get',
        url: this.pagination.path,
        params: {
          page: currentPage + 1
        }
      }).then(res => {
        this.cards = res.data.data.cards
        this.pagination = res.data.meta
      }).catch(err => {
        console.log(err.response.data.message)
      })
    },
    precedente() {
      let currentPage = this.pagination.current_page
      let riga = $('.riga')
      riga.children('.edit-card').css('display', 'none');
      riga.css('background-color', 'unset');
      riga.css('font-weight', 'unset');
      axios({
        method: 'get',
        url: this.pagination.path,
        params: {
          page: currentPage - 1
        }
      }).then(res => {
        this.cards = res.data.data.cards
        this.pagination = res.data.meta
      }).catch(err => {
        console.log(err.response.data.message)
      })
    },
    openEdit(codice) {
      let riga = $('#' + codice)

      if (riga.children('.edit-card').css('display') === 'none') {
        riga.children('.edit-card').css('display', 'flex');
        riga.css('background-color', 'var(--green)');
        riga.css('font-weight', 'bold');
      }
    },
    closeEdit(codice) {
      let riga = $('#' + codice)
      if (riga.children('.edit-card').css('display') === 'flex') {
        riga.children('.edit-card').css('display', 'none');
        riga.css('background-color', 'unset');
        riga.css('font-weight', 'unset');
      }
      this.edit = {
        new_card: null,
        cod_macrofamiglia: null,
        cod_famiglia: null,
        cod_microfamiglia: null,
        cod_categoria: null,
        cod_colore: null
      }
    }
  },

}
</script>

<style lang="scss" scoped>
#app_content {
  .titolo {
    font-size: 1.5rem;
    text-transform: uppercase;
    margin-bottom: 5px;
  }

  h6 {
    margin-bottom: 30px;
  }

  .search-box {
    text-transform: uppercase;
    margin-bottom: 15px;

    &::placeholder {
      text-transform: lowercase;
    }
  }

  .ultimi-20 {
    width: 100%;

    .intestazione {
      font-weight: bold;
      text-align: center;

      .cella {
        border-right: 1px solid #000000;
        border-top: 1px solid #000000;
        border-bottom: 1px solid #000000;
      }

      .cella:first-child {
        border-left: 1px solid #000000;
      }
    }

    .intestazione, .riga {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;

      .cella {
        width: 16.5%;
        border-right: 1px solid rgba(0, 0, 0, 0.4);
        border-bottom: 1px solid rgba(0, 0, 0, 0.4);
      }

      .cella:first-child {
        border-left: 1px solid rgba(0, 0, 0, 0.4);
      }
    }

    .riga {
      flex-direction: column;
      font-size: .8rem;
      cursor: pointer;

      .contenuto {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .edit-card {
        display: none;
        width: 100%;
        flex-wrap: wrap;
        justify-content: space-between;

        input, select {
          width: 16.5%;
        }

        input {
          background-color: #ffffff;
          text-transform: uppercase;
        }

        margin-top: 3px;
        margin-bottom: 10px;

        .button-cards {
          margin-top: 3px;
          width: 100%;
        }
      }
    }

    .riga:hover {
      background-color: var(--green);
    }

    .paginazione {
      margin-top: 20px;
      width: 100%;
      display: flex;
      justify-content: center;

      .prev, .next {
        cursor: pointer;
        margin: 0 10px;

        &.fine {
          color: transparent;
        }
      }
    }
  }

  .wrap {
    padding: 40px;
    border: 1px solid black;
    margin-top: 40px;
    position: relative;

    .titolo-new {

      position: absolute;
      background-color: white;
      left: 20px;
      top: 0;
      transform: translate(0, -50%);
      padding: 0 2px;
    }
  }

  .inser-heading {

    width: 100%;
    display: flex;
    justify-content: space-between;

    .head {
      width: 16.5%;
      text-align: center;
    }
  }

  .insert-card {
    flex-wrap: wrap;
    width: 100%;
    display: flex;
    justify-content: space-between;

    input, select {
      width: 16.5%;
    }

    input {
      text-transform: uppercase;
    }

    button {
      margin-left: 50%;
      margin-top: 10px;
      width: 300px;
      transform: translate(-50%);
    }
  }
}
</style>
